module.exports = __webpack_public_path__ + "static/media/how-rewards-work-step-4.2448b08c.jpg";